import type { TSerializedWidget } from 'src/entities/workspace/types';

import { stashPendingReferenceWellsTree } from './reference-wells-pending-tree-registry';

/**
 * Host-adjacent reference-wells persistence (not entity fields).
 *
 * Call from a type-specific `mapX` before parsing typed internalState:
 *   const stripped = extractAndStashReferenceWellsTree(widget);
 *
 * Stashes raw `internalState.referenceWellsTree` for mount hydrate via
 * `takePendingReferenceWellsTree(uuid)`. Pair with
 * `mergeReferenceWellsIntoSerializedWidget` on serialize.
 */
export function extractAndStashReferenceWellsTree(widget: TSerializedWidget): TSerializedWidget {
  const internalState = widget.internalState;

  if (!internalState || typeof internalState !== 'object' || !('referenceWellsTree' in internalState)) {
    return widget;
  }

  const { referenceWellsTree, ...restInternalState } = internalState as Record<string, unknown>;

  stashPendingReferenceWellsTree(widget.uuid, referenceWellsTree);

  return {
    ...widget,
    internalState: restInternalState,
  };
}
